import { React } from 'react'
import '../../styles/AnimatedBackground.css'

export default function Home() {
  return (
    <div className="bg-gray-900 relative min-h-screen">
      <div className="animated-bg">
        <div className="el"></div>
      </div>
      <div className="relative z-10">
        <div className="relative isolate overflow-hidden pt-14">
          <div className="mx-auto max-w-7xl py-32 sm:py-48 lg:py-56 px-6 lg:px-8">
            <div className="flex flex-col lg:flex-row items-center justify-between gap-x-12">
              <div className="text-left lg:w-1/2">
                <h1 className="text-4xl font-bold tracking-tight text-white sm:text-6xl">
                  Hello,&nbsp;I'm <span className="text-indigo-500">Mercy Manyange </span>,&nbsp; a software developer
                </h1>
                <p className="mt-6 text-lg leading-8 text-gray-300 max-w-2xl">
                  I'm a software developer based in Cape Town, South Africa. I'm passionate about learning new technologies and sharing knowledge with others.
                </p>
                <div className="mt-10 flex items-center gap-x-6">
                  <a
                    href="#contact-section"
                    className="rounded-md bg-indigo-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-400"
                  >
                    Contact Me
                  </a>
                  <a href="#solutions-section" className="text-sm font-semibold leading-6 text-white hover:text-gray-300">
                    Learn more <span aria-hidden="true">→</span>
                  </a>
                </div>
              </div>

              <div className="mt-10 lg:mt-0 lg:w-1/2 flex justify-center lg:justify-end">
                <img
                  src="/mercy.png"
                  alt="Mercy Manyange"
                  className="rounded-2xl w-[80%] max-w-[500px] object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
